import styled from 'styled-components/native';

import { ThemeProp } from 'config/getThemeForProducts';

export const Text = styled.Text<ThemeProp>`
  font-family: ${p => p.theme.text.fontFamily};
`;
